// This is a generated file! Please edit source .ksy file and use kaitai-struct-compiler to rebuild

import KaitaiStream from 'kaitai-struct/KaitaiStream';

var Lator = (function() {
  function Lator(_io, _parent, _root) {
    this._io = _io;
    this._parent = _parent;
    this._root = _root || this;

    this._read();
  }
  Lator.prototype._read = function() {
    this._unnamed0 = this._io.ensureFixedContents([76, 97, 116, 111, 114, 49, 48, 50]);
    this.name = new String(this._io, this, this._root);
    this.activePageId = this._io.readU4be();
    this.fontDefinitionsCount = this._io.readU4be();
    this.pagesCount = this._io.readU4be();
    this.viewportOffset = new Point(this._io, this, this._root);
    this.viewportScale = this._io.readF8be();
    this.currentFontDefinition = new FontDefinition(this._io, this, this._root);
    this.fontDefinitions = new Array(this.fontDefinitionsCount);
    for (var i = 0; i < this.fontDefinitionsCount; i++) {
      this.fontDefinitions[i] = new FontDefinition(this._io, this, this._root);
    }
    this.pages = new Array(this.pagesCount);
    for (var i = 0; i < this.pagesCount; i++) {
      this.pages[i] = new Page(this._io, this, this._root);
    }
  }

  var Point = Lator.Point = (function() {
    function Point(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    Point.prototype._read = function() {
      this.x = this._io.readF8be();
      this.y = this._io.readF8be();
    }

    return Point;
  })();

  var FontDefinition = Lator.FontDefinition = (function() {
    function FontDefinition(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    FontDefinition.prototype._read = function() {
      this.length = this._io.readU4be();
      this._raw_data = this._io.readBytes(this.length);
      var _io__raw_data = new KaitaiStream(this._raw_data);
      this.data = new Data(_io__raw_data, this, this._root);
    }

    var Data = FontDefinition.Data = (function() {
      function Data(_io, _parent, _root) {
        this._io = _io;
        this._parent = _parent;
        this._root = _root || this;

        this._read();
      }
      Data.prototype._read = function() {
        this.name = new String(this._io, this, this._root);
        this.fontFamily = new String(this._io, this, this._root);
        this.fontStyle = new String(this._io, this, this._root);
        this.fontSize = this._io.readF8be();
        this.lineHeightAuto = this._io.readU1();
        this.lineHeight = this._io.readF8be();
        this.leading = this._io.readF8be();
        this.kerning = this._io.readF8be();
        this.tracking = this._io.readF8be();
        this.color = new Color(this._io, this, this._root);
        this.verticalScale = this._io.readF8be();
        this.horizontalScale = this._io.readF8be();
        this.baselineShift = this._io.readF8be();
        this.fauxBold = this._io.readU1();
        this.fauxItalic = this._io.readU1();
        this.allCaps = this._io.readU1();
        this.smallCaps = this._io.readU1();
        this.superscript = this._io.readU1();
        this.subscript = this._io.readU1();
        this.underline = this._io.readU1();
        this.strikethrough = this._io.readU1();
        this.language = new String(this._io, this, this._root);
        this.textAlign = new String(this._io, this, this._root);
        this.verticalAlign = new String(this._io, this, this._root);
        this.outlineSizeAuto = this._io.readU1();
        this.outlineSize = this._io.readF8be();
        this.outlineColor = new Color(this._io, this, this._root);
      }

      return Data;
    })();

    return FontDefinition;
  })();

  var Page = Lator.Page = (function() {
    function Page(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    Page.prototype._read = function() {
      this.length = this._io.readU4be();
      this._raw_data = this._io.readBytes(this.length);
      var _io__raw_data = new KaitaiStream(this._raw_data);
      this.data = new Data(_io__raw_data, this, this._root);
    }

    var Data = Page.Data = (function() {
      function Data(_io, _parent, _root) {
        this._io = _io;
        this._parent = _parent;
        this._root = _root || this;

        this._read();
      }
      Data.prototype._read = function() {
        this.id = this._io.readU4be();
        this.name = new String(this._io, this, this._root);
        this.width = this._io.readF8be();
        this.height = this._io.readF8be();
        this.sourceLayerId = this._io.readU4be();
        this.selectedLayerId = this._io.readU4be();
        this.viewportOffset = new Point(this._io, this, this._root);
        this.viewportScale = this._io.readF8be();
        this.viewportSelectionExists = this._io.readU1();
        this.selection = new Range(this._io, this, this._root);
        this.layersCount = this._io.readU4be();
        this.layers = new Array(this.layersCount);
        for (var i = 0; i < this.layersCount; i++) {
          this.layers[i] = new Layer(this._io, this, this._root);
        }
      }

      return Data;
    })();

    return Page;
  })();

  var String = Lator.String = (function() {
    function String(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    String.prototype._read = function() {
      this.length = this._io.readU4be();
      this.value = KaitaiStream.bytesToStr(this._io.readBytes(this.length), "UTF-8");
    }

    return String;
  })();

  var Color = Lator.Color = (function() {
    function Color(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    Color.prototype._read = function() {
      this.r = this._io.readU1();
      this.g = this._io.readU1();
      this.b = this._io.readU1();
      this.a = this._io.readU1();
    }

    return Color;
  })();

  var Layer = Lator.Layer = (function() {
    function Layer(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    Layer.prototype._read = function() {
      this.length = this._io.readU4be();
      this._raw_data = this._io.readBytes(this.length);
      var _io__raw_data = new KaitaiStream(this._raw_data);
      this.data = new Data(_io__raw_data, this, this._root);
    }

    var Data = Layer.Data = (function() {
      function Data(_io, _parent, _root) {
        this._io = _io;
        this._parent = _parent;
        this._root = _root || this;

        this._read();
      }
      Data.prototype._read = function() {
        this.id = this._io.readU4be();
        this.type = new String(this._io, this, this._root);
        this.name = new String(this._io, this, this._root);
        this.x = this._io.readF8be();
        this.y = this._io.readF8be();
        this.width = this._io.readF8be();
        this.height = this._io.readF8be();
        this.opacity = this._io.readF8be();
        this.visible = this._io.readU1();
        this.blendingMode = new String(this._io, this, this._root);
        this.imageDataLength = this._io.readU4be();
        this.extraDataLength = this._io.readU4be();
        this.imageData = this._io.readBytes(this.imageDataLength);
        if (this.type.value == "clean") {
          this._raw_extraDataClean = this._io.readBytes(this.extraDataLength);
          var _io__raw_extraDataClean = new KaitaiStream(this._raw_extraDataClean);
          this.extraDataClean = new ExtraDataClean(_io__raw_extraDataClean, this, this._root);
        }
        if (this.type.value == "text") {
          this._raw_extraData = this._io.readBytes(this.extraDataLength);
          var _io__raw_extraData = new KaitaiStream(this._raw_extraData);
          this.extraData = new ExtraDataText(_io__raw_extraData, this, this._root);
        }
      }

      return Data;
    })();

    var ExtraDataClean = Layer.ExtraDataClean = (function() {
      function ExtraDataClean(_io, _parent, _root) {
        this._io = _io;
        this._parent = _parent;
        this._root = _root || this;

        this._read();
      }
      ExtraDataClean.prototype._read = function() {
        this.maskLength = this._io.readU4be();
        this.mask = this._io.readBytesFull();
      }

      return ExtraDataClean;
    })();

    var ExtraDataText = Layer.ExtraDataText = (function() {
      function ExtraDataText(_io, _parent, _root) {
        this._io = _io;
        this._parent = _parent;
        this._root = _root || this;

        this._read();
      }
      ExtraDataText.prototype._read = function() {
        this.baseWidth = this._io.readF8be();
        this.baseHeight = this._io.readF8be();
        this.boundsMode = new String(this._io, this, this._root);
        this.crosshair = new Point(this._io, this, this._root);
        this.cleanLayerId = this._io.readU4be();
        this.text = new String(this._io, this, this._root);
        this.fontDefinition = new FontDefinition(this._io, this, this._root);
        this.angle = this._io.readF8be();
      }

      return ExtraDataText;
    })();

    return Layer;
  })();

  var Range = Lator.Range = (function() {
    function Range(_io, _parent, _root) {
      this._io = _io;
      this._parent = _parent;
      this._root = _root || this;

      this._read();
    }
    Range.prototype._read = function() {
      this.left = this._io.readF8be();
      this.top = this._io.readF8be();
      this.right = this._io.readF8be();
      this.bottom = this._io.readF8be();
    }

    return Range;
  })();

  return Lator;
})();

export default Lator;

